export default "__VITE_ASSET__DD7Yf6yJ__"